// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import './assets/styles/index.css'
Vue.config.productionTip = false

/* eslint-disable no-new */
Vue.use(ElementUI);
Vue.use(ViewUI);
new Vue({
    el: '#app',
    render: h => h(App)
});